import React, { useEffect, useState } from "react";
import "./myPolicy.css";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Select } from "antd";
import Carousels from "../../../components/Slider/index";
import AxiosInstance from "../../../AxiosInstance";
import UseIsMobile from "../../../feature/ismobilescreen";
import { MyPolicyCarousel } from "../../../utils/index";
import { useMediaQuery } from "react-responsive";
import {
  insurerListController,
  productListController,
} from "../../Helper/provider";
import { Option } from "antd/es/mentions";
import { alertError } from "../../Helper/Alerts";

export default function MyPolicy() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ mode: "onChange" });
  const navigate = useNavigate();
  const { width } = UseIsMobile();
  const [isMobScreen, setMobScreen] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const [insurer, setInsurer] = useState([]);
  const [productList, setProductList] = useState([]);
  useEffect(() => {
    getSpinnerData();
  }, []);

  const getSpinnerData = async () => {
    const result = await insurerListController();

    setInsurer(result);
  };

  const onSubmit = (value) => {
    value.insurerId = parseInt(value.insurerId);
    value.annualPremium = parseInt(value.annualPremium);
    value.productId = parseInt(value.productId);
    AxiosInstance()
      .post("/policy", value)
      .then((resp) => {
        let { data } = resp;
        navigate("/phdashboard");
      })
      .catch((err) => {
        alertError(err.response.data.message);
      });
  };
  const insurerChange = (insurerId) => {
    errors.insurerId = false;
    setValue("insurerId", insurerId);
    getPlanNames(insurerId);
  };
  const getPlanNames = async (id) => {
    const result1 = await productListController(id);
    setProductList(result1);
  };
  const planNameChange = (planNameId) => {
    errors.productId = false;
    setValue("productId", planNameId);
  };
  useEffect(() => {
    if (width <= 768) {
      setMobScreen(true);
    } else {
      setMobScreen(false);
    }
  }, [isMobScreen, width]);
  return (
    <div className="main-wrapper">
      <div className="row mobile-view">
        {!isMobScreen && (
          <div className="col-md-7 d-md-flex d-none  leftDivOTP">
            <div className="col-7">
              {MyPolicyCarousel.img}
              <p style={{ fontSize: "20px", marginTop: "10px" }}>
                {MyPolicyCarousel.text}
              </p>
            </div>
            {/* 
            <Carousels
              CarouselList={MyPolicyCarousel}
              ClassProps="slik-slider-signup"
            /> */}
          </div>
        )}
        <div className="col-lg-offset-1 col-md-4 ">
          <div className="p-3 w-md-100 tre-login-block text-start">
            <button
              type="submit"
              title="back-button"
              className="back-button mt-3 mb-4"
              onClick={() => navigate(-1)}
            >
              {" "}
              <i className="fa fa-angle-left" /> Back
            </button>
            <h2 className="mt-5">Add Policy</h2>
            <p>It just takes a minute to make your life insurance policy work for you! </p>
            <form id="policyDetailsForm" onSubmit={handleSubmit(onSubmit)}>
              <div className={`form-group col-12`}>
                <label htmlFor="policyNumber">Policy Number</label>
                <div className="input-group pb-3">
                  <input
                    type="text"
                    className={`form-control${
                      errors.policyNumber ? " is-invalid" : ""
                    }`}
                    id="policyNumber"
                    // aria-describedby="emailHelp"
                    placeholder="Enter your Policy Number"
                    {...register("policyNumber", {
                      required: true,
                      // value: /^[0-9]*$/i,
                      // message: "invalid value",
                      pattern: {
                        // value: /^-?\d+(-\d+)*$/i,
                        value: /^[0-9EUALIeuail-]+$/,
                        message: "should be a non negative number",
                      },
                    })}
                  />

                  <div className="invalid-feedback">
                    {errors?.policyNumber?.message}
                  </div>
                </div>

                <label htmlFor="insurer">Insurance Co.</label>
                <div className="pb-3">
                  <Controller
                    name="insurerId"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <Select
                        className={`${errors.insurerId ? "is-invalid" : ""}`}
                        placeholder="Select Insurer"
                        onChange={insurerChange}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {insurer.map((item) => (
                          <Option key={item.insurerId} value={item.insurerID}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />

                  <div className="invalid-feedback">
                    Insurance Co. is required
                  </div>
                </div>

                <label htmlFor="annualPremium">Annual Premium Amount</label>
                <div className="input-group pb-3">
                  <input
                    className={`form-control${
                      errors.annualPremium ? " is-invalid" : ""
                    }`}
                    id="annualPremium"
                    placeholder="Enter Premium Amount"
                    {...register("annualPremium", {
                      min: {
                        value: 5000,
                        message:
                          "annual premium should be greater or equal to 5000", // JS only: <p>error message</p> TS only support string
                      },
                      required: true,
                      pattern: {
                        value: /^[0-9]*$/i,

                        message: "invalid value",
                      },
                    })}
                  />
                  <div className="invalid-feedback">
                    {errors?.annualPremium?.message}
                  </div>
                </div>

                <label htmlFor="premium-mode">Plan Name</label>

                <div className="pb-3">
                  <Controller
                    name="productId"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <Select
                        placeholder="Select Plan Name"
                        className={`${errors.productId ? "is-invalid" : ""}`}
                        onChange={planNameChange}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {productList.map((item) => (
                          <Option key={item.productId} value={item.productId}>
                            {item.productName}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                  <div className="invalid-feedback">Plan Name is required</div>
                </div>
              </div>
            </form>

            <button
              form="policyDetailsForm"
              className="normal-button w-100 mb-3"
            >
              Submit
            </button>
            <div className="skip-text d-flex justify-content-center align-items-center font-14">
              Skip for now?
              <button
                className="back-button skip-ph mx-2"
                onClick={() => {
                  navigate("/phdashboard");
                }}
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
